export default class User {
  constructor (data) {
    this.id = typeof data === 'undefined' ? null : data.id
    this.firstname = typeof data === 'undefined' ? null : data.firstname
    this.lastname = typeof data === 'undefined' ? null : data.lastname
    this.email = typeof data === 'undefined' ? null : data.email
    this.__role = typeof data === 'undefined' ? null : data.roles.reduce((acc, r) => {
      if (acc === null) {
        return r
      }
      if (r === null) {
        return acc
      }
      return r > acc ? acc : r
    }, null)
    this.role = this.__role
  }

  clone () {
    const clone = new User()
    clone.id = this.id
    clone.firstname = this.firstname
    clone.lastname = this.lastname
    clone.email = this.email
    clone.role = this.role
    clone.__role = this.__role
    return clone
  }

  hasChangedRole () {
    return this.role !== this.__role
  }

  getData () {
    const data = {
      firstname: this.firstname,
      lastname: this.lastname
    }
    if (!this.id) {
      data.email = this.email
    }
    return data
  }
}



// WEBPACK FOOTER //
// ./src/users/entity/user.js